import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { Button } from 'storybook-ui'

import { Container } from 'components/Container'
import { FooterContainer } from 'components/FooterContainer'
import { RadiantSpinner } from 'components/RadiantSpinner'

import { selectAppName } from 'root-redux/selects/common'

import { PinnedNote } from 'modules/unsubscribe/components/PinnedNote'
import { RetentionPageContainer } from 'modules/unsubscribe/components/RetentionPageContainer'

import { RetentionPageTitle as Title } from 'common-styles'
import { APP_BUTTON_THEMES } from 'root-constants'

import { useCanceledPlan } from './useCanceledPlan'

export const CanceledPlan: React.FC = () => {
  const { t } = useTranslation()
  const appName = useSelector(selectAppName)
  const { isInProgress, goToAccountPage } = useCanceledPlan()

  return (
    <RetentionPageContainer>
      {isInProgress ? (
        <Container>
          <Title bottomMargin={48}>
            {t`retention.canceledPlan.step1Title`}
          </Title>
          <RadiantSpinner />
        </Container>
      ) : (
        <>
          <Container>
            <Title bottomMargin={48}>
              {t`retention.canceledPlan.step2Title`}
            </Title>
            <PinnedNote>{t`retention.canceledPlan.note`}</PinnedNote>
          </Container>
          <FooterContainer>
            <Button
              theme={APP_BUTTON_THEMES[appName]}
              onClick={goToAccountPage}
            >
              {t('retention.canceledPlan.okButton', { context: appName })}
            </Button>
          </FooterContainer>
        </>
      )}
    </RetentionPageContainer>
  )
}
